export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Главная", "item": { "@id": "https://business-training.by/", "name": "Главная" } },
          { "@type": "ListItem", "position": 2, "name": "Продажи и переговоры", "item": { "@id": "https://business-training.by/prodazhi-i-peregovory", "name": "Продажи и переговоры" } }
        ]
      },
      {
        "@type": "Service",
        "name": "Корпоративное обучение продажам и переговорам",
        "description": "Корпоративное обучение продажам и переговорам для компаний. Тренинги по B2B-продажам, переговорам, телефонным продажам, холодным звонкам, работе с возражениями и развитию отдела продаж. Индивидуальные программы под задачи бизнеса.",
        "provider": {
          "@type": "Organization",
          "name": "BusinessTraining.by",
          "url": "https://business-training.by",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Минск",
            "addressCountry": "BY"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+375255024478",
            "contactType": "sales"
          }
        },
        "areaServed": ["BY", "RU", "KZ", "IL"],
        "serviceType": "Корпоративное обучение",
        "offers": {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Программы корпоративного обучения продажам и переговорам"
          }
        }
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении продажам и переговорам. 100+ корпоративных проектов, 450+ тренингов, 4500+ участников.",
        "url": "https://www.linkedin.com/in/alekseysivko",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}